"use strict";

exports.__esModule = true;
exports.FormGroupField = FormGroupField;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _excluded = ["name", "helperText", "component", "className", "style", "disabled", "inline", "intent", "label", "requiredLabel", "render", "children", "validateOnPopup"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Wraps a Blueprint [FormGroup](http://blueprintjs.com/docs/v2/#core/components/forms/form-group)
 * with a Final Form [Field](https://github.com/final-form/react-final-form#field--reactcomponenttypefieldprops),
 * rendering validation errors where appropriate.
 */
function FormGroupField(_ref) {
  var name = _ref.name,
    helperText = _ref.helperText,
    Component = _ref.component,
    className = _ref.className,
    style = _ref.style,
    disabled = _ref.disabled,
    inline = _ref.inline,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? _core.Intent.NONE : _ref$intent,
    label = _ref.label,
    requiredLabel = _ref.requiredLabel,
    render = _ref.render,
    children = _ref.children,
    _ref$validateOnPopup = _ref.validateOnPopup,
    validateOnPopup = _ref$validateOnPopup === void 0 ? false : _ref$validateOnPopup,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var id = "field-" + name;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, _extends({
    name: name
  }, extra), function (_ref2) {
    var input = _ref2.input,
      meta = _ref2.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: (meta.modified || meta.touched || validateOnPopup) && meta.error ? _core.Intent.DANGER : intent,
      helperText: (meta.modified || meta.touched || validateOnPopup) && meta.error ? meta.error : helperText,
      className: className,
      disabled: disabled,
      inline: inline,
      label: label,
      labelFor: id,
      requiredLabel: requiredLabel,
      style: style
    }, Component ? /*#__PURE__*/_react["default"].createElement(Component, {
      input: input,
      id: id,
      meta: meta
    }) : (render || children)({
      input: Object.assign({}, input, {
        intent: (meta.modified || meta.touched || validateOnPopup) && meta.error ? _core.Intent.DANGER : undefined,
        id: id
      }),
      meta: meta
    }));
  });
}